import React, { useRef } from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import BackToTopButton from "./back-to-top-btn"
import BlogPostHeader from "./post-header"
import parse from "html-react-parser"
import BlogSharePanel from "./share-panel"
import RelatedPosts from "./related-posts"
import ArticleBanner from "./banner"
import AldooTransferBanner from "@components/AldooTransferBanner"
import BubblesBg from "@components/Site/BubblesBg/BubblesBg"
import PageLike from "./page-like"
import Text from "aldoo-ra/Text"
import { updateCDNUrls } from "aldoo-ra/HtmlEditor/cdn-urls"

const BlogPost = ({ postID }) => {
  const contentRef = useRef(null)
  return (
    <div className="w-full px-[16px] py-4 md:py-10 lg:py-[64px] xl:py-[80px] overflow-hidden">
      <CMSRender
        contentType="BlogPost"
        match={{ "content.slug": postID }}
        renderItem={(post, id) => {
          return (
            <div key={id} className="w-full mx-auto">
              <BackToTopButton content={contentRef} />
              <BlogPostHeader post={post} />

              {/* Article Layout */}
              <div className="w-full max-w-[580px] md:max-w-[700px] lg:max-w-[860px] xl:max-w-[1035px] flex flex-col items-start justify-between gap-12 mx-auto">
                {/* Article Content */}
                <article ref={contentRef} className="w-full text-text">
                  {(() => {
                    const html = post.content ? updateCDNUrls(post.content) : ""
                    if (!html) return "Empty"
                    // Inject the AldooTransferBanner after the 2nd paragraph.
                    // Split the raw HTML at the 2nd </p> so html-react-parser
                    // gets balanced fragments on each side.
                    const tag = "</p>"
                    let idx = -1
                    for (let i = 0; i < 2; i++) {
                      idx = html.indexOf(tag, idx + 1)
                      if (idx < 0) break
                    }
                    if (idx < 0) return parse(html)
                    const before = html.slice(0, idx + tag.length)
                    const after = html.slice(idx + tag.length)
                    return (
                      <>
                        {parse(before)}
                        <AldooTransferBanner placement="blog-article" />
                        {parse(after)}
                      </>
                    )
                  })()}
                </article>

                <div className="w-full flex justify-center">
                  <PageLike
                    target={post}
                    variant="like_btn_big"
                    label={<Text id="like_article" className="my-0" />}
                  />
                </div>

                {/* Bottom Content */}
                <div className="w-full flex flex-col gap-6 md:gap-10 lg:gap-[80px] xl:gap-[96px]">
                  {/* Download Banner */}
                  <ArticleBanner />

                  {/* Share Panel - temporary style */}
                  <BlogSharePanel />
                </div>
              </div>

              <RelatedPosts post={post} numberOfRelated={3} />
            </div>
          )
        }}
      />

      <BubblesBg />
    </div>
  )
}

export default BlogPost